module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('block', {
    attrs: {
      "title": "Contact"
    }
  }, [_c('div', {
    attrs: {
      "id": "contact"
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": _vm.mailUrl
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("Contactez-moi par mail")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.contact.github,
      "target": "_blank"
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "github-alt",
      "scale": "6"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("Découvrez mon GitHub")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.contact.linkedin,
      "target": "_blank"
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "linkedin",
      "scale": "6"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("Retrouvez-moi sur LinkedIn")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.contact.twitter,
      "target": "_blank"
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "twitter",
      "scale": "6"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("Suivez-moi sur Twitter")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d3b4396"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 289
// module chunks = 1